import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useGetCustomSectionDefinitions = function () {
    return useApiCall(function (signal) { return api.customSections.apiCustomFieldSectionGet({ signal: signal }); }, null, true, []);
};
